var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverwrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.134 14.513 0.941 -0.939a0.989 0.989 0 1 0 -1.398 -1.397l-2.625 2.625a0.99 0.99 0 0 0 0 1.397l2.625 2.625a0.989 0.989 0 1 0 1.398 -1.397l-0.941 -0.939h11.616a1.86 1.86 0 0 0 1.863 -1.863V3.25A1.86 1.86 0 0 0 20.75 1.388H8.5a1.86 1.86 0 0 0 -1.863 1.863v0.874a0.989 0.989 0 0 0 1.975 0v-0.762h12.024v11.149zm5.732 -5.025 -0.941 0.939a0.989 0.989 180 1 0 1.398 1.397l2.625 -2.625a0.99 0.99 180 0 0 0 -1.397l-2.625 -2.625a0.989 0.989 180 1 0 -1.398 1.397l0.941 0.939H3.249A1.86 1.86 180 0 0 1.386 9.375v11.375a1.86 1.86 180 0 0 1.863 1.863h12.249a1.86 1.86 180 0 0 1.863 -1.863v-0.874a0.989 0.989 180 0 0 -1.975 0v0.762H3.362V9.488z",
    fill: "#525866",
    stroke: "currentColor",
    strokeWidth: 0.22499999999999998
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverwrite);
export default __webpack_public_path__ + "static/media/overwrite.bf8b6359b705e42992676099dd88ae42.svg";
export { ForwardRef as ReactComponent };